import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';

import { setPageTitle } from '../../../redux/title/title.slice';
import { getProviders } from '../../../redux/providers/providers.slice';
import Loader from '../../../components/ui/loader';

import { FTable, FTableCell } from '../../../components/ui/table';

function Providers() {
  const dispatch = useDispatch();

  const { providers, loading } = useSelector((state) => state.providers);

  useEffect(() => {
    dispatch(setPageTitle('Service Providers'));
    dispatch(getProviders());
  }, [dispatch]);

  if (loading) {
    return <Loader loading={true} message="Loading providers ..." />;
  }

  if (!providers || providers.length === 0) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <Typography>No providers found</Typography>
      </Box>
    );
  }

  const columns = [{ label: 'Manco / LISP Name' }, { label: 'Broker House Code' }];

  return (
    <FTable
      title="Service Providers"
      columns={columns}
      rows={providers}
      emptyMessage="No providers found"
      renderRow={(provider) => (
        <>
          <FTableCell>{provider.friendlyName || provider.clientName || '—'}</FTableCell>

          <FTableCell>{provider.externalId1 || '—'}</FTableCell>
        </>
      )}
    />
  );
}

export default Providers;
